import React, { Fragment, useEffect, useState } from "react";

import axios from "axios";

import { Link } from "react-router-dom";

import { useRecoilValue, useSetRecoilState } from "recoil";
import dropdownTrxListNotificationStore from "../../store/dropdown-notification.store";
import themeAppStore from "../../store/theme-app.store";

import toast from "react-hot-toast";

import moment from "moment";

import ReactSweetAlert2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import "./Dropdown.css";

const Swal: typeof ReactSweetAlert2 = withReactContent(ReactSweetAlert2);


const idLocale = require('moment/locale/id')
moment.updateLocale('id', idLocale);

interface DropdownTrxNotificationProps {
	animateClass?: string;
}

const DropdownTrxNotification: React.FC<DropdownTrxNotificationProps> = ({ animateClass }): JSX.Element => {
	const setDropdownTrxListNotification = useSetRecoilState<boolean>(dropdownTrxListNotificationStore);

	interface TrxNotificationListSchemaType {
		created_at: string;
		kode_merchant: string;
		penerima: string;
		pengirim: string;
		pesan: string;
		status: number;
		tipe: string;
		updated_at: string;
		user_id?: string;
	}

	const trxNotificationListSchema = [
		{
			created_at: "",
			kode_merchant: "",
			penerima: "",
			pengirim: "",
			pesan: "",
			status: 0,
			tipe: "",
			updated_at: "",
			user_id: "",
		},
	];

	const [trxNotificationListState, setTrxNotificationListState] = useState<Array<TrxNotificationListSchemaType>>(trxNotificationListSchema);

	let notificationMaxLength: number = 5;

	const [isLoadingState, setIsLoadingState] = useState<boolean>(false);

	function getTrxNotificationList(): Promise<unknown> {
		return new Promise((resolve, reject): void => {
			setIsLoadingState(true);
			axios({
				url: `${process.env.REACT_APP_API_ENDPOINT_URL}/outbox/list`,
				method: "GET",
				headers: {
					Authorization: localStorage.getItem("user_token"),
				},
				validateStatus: (status): boolean => true,
			}).then((result: any): void => {
				// console.log("[NOTIFICATION LIST]", result);

				if (result.status === 200) {
					setIsLoadingState(false);
					resolve(result);
				} else {
					reject(result);
				}

			}).catch((error: any): void => console.log("STATUS CODE", error));
		});
	};

	useEffect((): void => {
		getTrxNotificationList().then((result: any): void => {
			const statusCode = result.data.status;
			const data = result.data.data;
			if (statusCode === 200) {
				setTrxNotificationListState(data);
			}
		}).catch((e: any): void => {
			toast.error(e.data.message, {
				style: { fontWeight: "bolder" },
			});
			console.log(e);
		});
	}, []);

	const themeState = useRecoilValue<string | null>(themeAppStore);

	interface primaryThemeModeType {
		backgroundColor: string;
		color: string
	}

	let primaryThemeMode: primaryThemeModeType = {
		backgroundColor: process.env.REACT_APP_PRIMARY_COLOR ?? "#FFFFFF",
		color: process.env.REACT_APP_PRIMARY_COLOR ? "#FFFFFF" : "#000000",
	};

	interface arrowUpThemeModeType {
		borderBottomColor: string;
	}

	let arrowUpThemeMode: arrowUpThemeModeType = {
		borderBottomColor: process.env.REACT_APP_PRIMARY_COLOR ?? "#FFFFFF",
	};

	if (themeState === 'dark') {
		primaryThemeMode.backgroundColor = "#1F283E";
		primaryThemeMode.color = "#FFFFFF";
		arrowUpThemeMode.borderBottomColor = "#dad9d9";
	}

	const defaultTheme = {
		text: 'lg:text-black',
		icon: 'lg:text-gray-600',
		spinIcon: 'text-black',
		secondLine: 'text-gray-800',
		dropdownTrxListNotification: 'bg-white text-gray-400 lg:text-gray-800',
		borderDropdownTrxListNotification: ''
	}

	if (themeState === 'dark') {
		defaultTheme['text'] = 'lg:text-gray-100';
		defaultTheme['icon'] = 'lg:text-gray-100';
		defaultTheme['spinIcon'] = 'text-white';
		defaultTheme['secondLine'] = 'text-gray-400';
		defaultTheme['dropdownTrxListNotification'] = 'bg-dark-dropdown lg:text-gray-200 border-gray-700';
		defaultTheme['borderDropdownTrxListNotification'] = 'border-gray-700';
	}

	return (
		<div
			className={`${animateClass} hidden lg:block w-96 fixed z-40 top-1 lg:mt-16 mb-4 pt-0`} style={{ right: "5.1rem" }}>
			<div className="flex justify-end px-4">
				<div className="arrow-up" style={arrowUpThemeMode}></div>
			</div>
			<div
				className={`${defaultTheme.dropdownTrxListNotification} rounded-lg shadow-md ${!trxNotificationListState.length ? "pb-1" : ''}`}>

				{/* TRX NOTIFICATION LIST*/}
				<div
					className={`${defaultTheme.borderDropdownTrxListNotification} flex justify-center items-center gap-3 px-2 py-2 rounded-lg rounded-b-none border-b`} style={primaryThemeMode}>
					<div className="mb-0.5 px-2.5">
						<span className="text-lg font-medium capitalize tracking-wider">Notifikasi Transaksi</span>
					</div>
				</div>

				{isLoadingState ? (
					<div className="flex justify-center items-center py-5">
						<svg
							className={`${defaultTheme.spinIcon} animate-spin -ml-1 mr-3 h-5 w-5`}
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24">
							<circle className="opacity-25" cx={12} cy={12} r={10} stroke="currentColor" strokeWidth={4} />
							<path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
						</svg>
					</div>
				) : (
					<Fragment>
						{!trxNotificationListState.length ? (
							<div className="text-sm flex justify-center py-5">
								<span>Anda Belum Memiliki Riwayat Notifikasi..</span>
							</div>
						) : (
							<Fragment>
								{trxNotificationListState.slice(0, notificationMaxLength).map(
									({ pesan: message, created_at: createdAt }, index): JSX.Element => (
										<Fragment key={index}>
											<div
												onClick={(e: any) => {
													Swal.fire({
														title: 'Detail Notifikasi Tranksaksi',
														padding: "1rem 0rem",
														showConfirmButton: false,
														showCancelButton: true,
														cancelButtonText: "Tutup",
														heightAuto: false,
														customClass: {
															title: "font-inter font-semibold text-lg lg:text-2xl text-gray-800",
															cancelButton: "text-sm lg:text-base font-inter",
															confirmButton: "text-sm lg:text-base font-inter",
														},
														html: (
															<div className="flex flex-col justify-center items-center">
																<span className="text-sm lg:text-base font-medium font-dmsans">{message}</span>
															</div>
														),
													});
												}}
												className={`${defaultTheme.borderDropdownTrxListNotification} flex items-center gap-2 px-2 py-4 border-b cursor-pointer`}>
												<span className="pl-4 pr-3">
													<svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M12 10.5199C11.59 10.5199 11.25 10.1799 11.25 9.76994V6.43994C11.25 6.02994 11.59 5.68994 12 5.68994C12.41 5.68994 12.75 6.02994 12.75 6.43994V9.76994C12.75 10.1899 12.41 10.5199 12 10.5199Z" fill="currentColor" />
														<path d="M12.0199 20.3502C9.43987 20.3502 6.86987 19.9402 4.41987 19.1202C3.50987 18.8202 2.81987 18.1702 2.51987 17.3502C2.21987 16.5302 2.31987 15.5902 2.80987 14.7702L4.07987 12.6502C4.35987 12.1802 4.60987 11.3002 4.60987 10.7502V8.65023C4.60987 4.56023 7.92987 1.24023 12.0199 1.24023C16.1099 1.24023 19.4299 4.56023 19.4299 8.65023V10.7502C19.4299 11.2902 19.6799 12.1802 19.9599 12.6502L21.2299 14.7702C21.6999 15.5502 21.7799 16.4802 21.4699 17.3302C21.1599 18.1802 20.4799 18.8302 19.6199 19.1202C17.1699 19.9502 14.5999 20.3502 12.0199 20.3502ZM12.0199 2.75023C8.75987 2.75023 6.10987 5.40023 6.10987 8.66023V10.7602C6.10987 11.5702 5.78987 12.7402 5.36987 13.4302L4.09987 15.5602C3.83987 15.9902 3.77987 16.4502 3.92987 16.8502C4.07987 17.2502 4.41987 17.5502 4.89987 17.7102C9.49987 19.2402 14.5599 19.2402 19.1599 17.7102C19.5899 17.5702 19.9199 17.2502 20.0699 16.8302C20.2299 16.4102 20.1799 15.9502 19.9499 15.5602L18.6799 13.4402C18.2599 12.7502 17.9399 11.5802 17.9399 10.7702V8.67023C17.9299 5.40023 15.2799 2.75023 12.0199 2.75023Z" fill="currentColor" />
														<path d="M11.9999 22.8998C10.9299 22.8998 9.87992 22.4598 9.11992 21.6998C8.35992 20.9398 7.91992 19.8898 7.91992 18.8198H9.41992C9.41992 19.4998 9.69992 20.1598 10.1799 20.6398C10.6599 21.1198 11.3199 21.3998 11.9999 21.3998C13.4199 21.3998 14.5799 20.2398 14.5799 18.8198H16.0799C16.0799 21.0698 14.2499 22.8998 11.9999 22.8998Z" fill="currentColor" />
													</svg>
												</span>
												<div className="w-72">
													<div className="truncate">
														<span className={`text-[0.999rem] ${defaultTheme.text} font-medium capitalize tracking-wider`}>{message}</span>
													</div>
													<div>
														<span className={`${defaultTheme.secondLine} text-sm font-medium capitalize tracking-wider`}>{moment.utc(createdAt).format("DD MMMM YYYY HH:mm:ss")} WIB</span>
													</div>
												</div>
											</div>
										</Fragment>
									)
								)}

								<div className="flex justify-center items-center gap-3 px-2 py-2 rounded-sm cursor-pointer">
									<Link to="/dashboard/profile/trx/notification/show">
										<div
											onClick={(): void => setDropdownTrxListNotification(false)}
											className="mb-0.5 px-2.5">
											<span className={`text-base ${defaultTheme.icon} font-medium capitalize hover:underline`}>Lihat Semua Notifikasi</span>
										</div>
									</Link>
								</div>
							</Fragment>
						)}
					</Fragment>
				)}
			</div>
		</div>
	);
};

export default DropdownTrxNotification;
